import { css, Flex } from 'theme-ui';
import { BASIC_CONTAINER_WIDTH } from '../../consts/style-consts';
import styled from '../../lib/transient-styled';
import { RegularAnchor } from '../../shared-styled/typography/Anchors';
import pxToRem from '../../utils/pixelsToRem';

export const Container = styled(Flex)(
  css({
    width: BASIC_CONTAINER_WIDTH,
    flexDirection: 'column',
    gap: '30px',
    padding: ['45px 10px 75px 0', '45px 15px 75px 0', '45px 5% 75px 0'],
    background: 'white',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
    borderRadius: '3px',
    marginTop: ['40px', '40px', '20px'],
  }),
);

export const AlphabetListFragment = styled(Flex)(
  css({
    flexDirection: 'column',
    gap: 2,
    fontSize: pxToRem(14),
  }),
);

export const AlphabetLetter = styled.h3(
  css({
    width: 'max-content',
    mb: '10px',
    padding: '0 10px 0 30px',
    textTransform: 'capitalize',
    lineHeight: pxToRem(22),
    fontWeight: '600',
    color: 'white',
    borderRadius: '0px 5px 5px 0px',
    background: 'secondaryGreen',
  }),
);

export const AlphabetLink = styled(RegularAnchor)(
  css({
    pr: '5px',
    '&:hover': {
      color: 'secondaryGreen',
    },
  }),
);

export const AlphabetLinkContainer = styled('div')(
  css({
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  }),
);

export const List = styled.div(
  css({
    ml: '36px',
    display: 'grid',
    gridTemplateColumns:
      'repeat(auto-fit, minmax(0, min(100%/1, max(176px, 100%/3))))',
    rowGap: '16px',
    justifyContent: 'left',
    justifyItems: 'left',
  }),
);
